




































import Vue, { PropType } from "vue"
import datasource from "@/datasource"
import type { AppUser } from "@/datasource/appUsers"

function initialData() {
  return {
    showDialog: false,
    loading: false,
    sendingVerificationEmail: false,
    sentVerificationEmail: false,
    verificationSuccess: true,
  }
}

export default Vue.extend({
  props: {
    appUser: {
      type: Object as PropType<AppUser>,
      required: true,
    },
  },

  data: initialData,

  watch: {
    showDialog(value) {
      if (!value) {
        this.close()
      }
    },
  },

  methods: {
    close() {
      Object.assign(this.$data, initialData())
    },

    async sendVerificationEmail() {
      this.sentVerificationEmail = false
      this.sendingVerificationEmail = true
      const result = await datasource.appUsers.sendVerificationEmail(
        this.appUser
      )
      if (result instanceof Error) {
        console.error(result)
        this.verificationSuccess = false
      } else {
        this.verificationSuccess = result
      }
      this.sendingVerificationEmail = false
      this.sentVerificationEmail = true
    },
  },
})
